import { render, staticRenderFns } from "./EntertainmentArticle.vue?vue&type=template&id=1daaaed7&scoped=true"
import script from "./EntertainmentArticle.vue?vue&type=script&lang=js"
export * from "./EntertainmentArticle.vue?vue&type=script&lang=js"
import style0 from "./EntertainmentArticle.vue?vue&type=style&index=0&id=1daaaed7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1daaaed7",
  null
  
)

export default component.exports